class FlashMessage {

    constructor(containerId) {
        const nodelist = document.querySelectorAll('[data-alert-onfocus-close]');

        this.container = document.getElementById(containerId);
        this.timeout = 15 * 1000; // 15 seconds

        [...nodelist].map((input) => {
            input.addEventListener('focus', () => {
                this.container.innerHTML = '';
            });
        });
    }

    add(type, message) {
        if (type === 'danger') {
            type = 'error';
        }
        const messageContainer = document.createElement('div');
        const resendBtnId = 'resend-verification-code';
        const alertContainer = 'alert-message-container';

        function removeFadeOut(el,speed) {
            let seconds = speed/1000;
            el.style.transition = "opacity "+seconds+"s ease";

            el.style.opacity = 0;
            setTimeout(function() {
                if (document.getElementById(alertContainer).firstChild) {
                    el.parentNode.removeChild(el);
                }
            }, speed);
        }

        messageContainer.setAttribute('class', 'alert alert-dismissible alert-' + type + ' fade show');
        messageContainer.setAttribute('role', 'alert');

        const icon = document.createElement('span');
        icon.setAttribute('class', 'alert-icon');

        const text = document.createElement('span');
        text.setAttribute('class', 'text-body');
        text.innerHTML = message;

        const buttonIcon = document.createElement('span');
        buttonIcon.setAttribute('aria-hidden', 'true');
        buttonIcon.innerHTML = '&#10006;';

        const button = document.createElement('button');
        button.setAttribute('class', 'btn close');
        button.setAttribute('type', 'button');
        button.setAttribute('data-bs-dismiss', 'alert');
        button.setAttribute('aria-label', 'Close');
        button.appendChild(buttonIcon);

        messageContainer.innerHTML = icon.outerHTML + text.outerHTML + button.outerHTML;
        this.container.appendChild(messageContainer);

        setTimeout(() => {
            if (messageContainer) {
                removeFadeOut(messageContainer, 2000);
                if (document.getElementById(resendBtnId)) {
                    document.getElementById(resendBtnId).disabled = false;
                }
            }
        }, this.timeout);
    }
}

export default FlashMessage;
